//import $ from 'jquery';
import Base from '../../../_config/base';

class BackToTop extends Base {
  constructor(el) {
    super(el);

    this.$el.find('a.call-to-action').on('click', this.handleScrollTo);
  }

  handleScrollTo(e) {
    e.preventDefault();
    //ScrollTo.to($('body'));
  }
}

BackToTop.className = 'BackToTop';
export default BackToTop;



// WEBPACK FOOTER //
// ./src/materials/molecules/back-to-top/back-to-top.js